/**
 * @param {string} str
 */
const removeOutsideQuotes = (str) => {
  if ((str[0] === '"' && str[str.length - 1] === '"') || str[0] === "'" && str[str.length - 1] === "'") {
    return str.slice(1, -1);
  }

  return str;
};

/**
 * @param {string} str
 */
const wrapQuotes = (str) => {
  return `"${str}"`;
};

module.exports = { removeOutsideQuotes, wrapQuotes };
